import Vue from "vue";

// Create a global event bus
export const EventBus = new Vue();

// Event constants
export const EVENTS = {
  REFRESH_WITHDRAWALS_DASHBOARD: "refresh-withdrawals-dashboard"
};
